import './lsp.scss';
import classNames from 'classnames';
import { useEffect, useRef } from 'react';

interface Props {
	onClose: () => void;
	wsData: any;
}

export default function LSPMiniGame(props: Props) {
	const { onClose, wsData } = props;
	const elWrapChar = useRef<HTMLDivElement>(null);
	const elWrapDiceChar1 = useRef<HTMLDivElement>(null);
	const elWrapDiceChar2 = useRef<HTMLDivElement>(null);
	const elWrapDiceChar3 = useRef<HTMLDivElement>(null);
	const elWrapTotal = useRef<HTMLDivElement>(null);
	const elWrapTotalDice = useRef<HTMLDivElement>(null);

	const getLatest = useRef({
		id: 0,
		result: [],
		txtResult: ''
	});
	const isHideDice1 = useRef(false);
	const isHideDice2 = useRef(false);
	const isHideDice3 = useRef(false);

	const hChart = useRef<number>(86);
	const wChart = useRef<number>(479);

	const totalNumTai = useRef<number>(0);
	const totalNumXiu = useRef<number>(0);
	const totalDotTai = useRef<number>(0);
	const totalDotXiu = useRef<number>(0);

	const btnxnDisa1 = useRef<string>('');
	const btnxnDisa2 = useRef<string>('');
	const btnxnDisa3 = useRef<string>('');

	const isHideChartPhien = useRef(false);
	const isHideTotalPhien = useRef(false);

	const renderChartDot123 = (arrDot: any, colorLine: any, clsDot: any) => {
		let htmlDot = '';
		const arrAnchorDot: any = [];
		arrDot.forEach((item: any, idx: number) => {
			const whDot = 12;
			const wColItem: number = Number(wChart.current) / 15;
			const hColItem: number = Number(hChart.current) / 5;
			const topDot = (6 - item) * hColItem - whDot / 2;
			const leftDot = (idx * wColItem) - whDot / 2;
			arrAnchorDot.push({ x: leftDot, y: topDot });
			htmlDot += `<span class="dot123 ${clsDot}" style="top: ${topDot}px; left: ${leftDot}px"></span>`;
		});
		arrAnchorDot.forEach((item: any, idx: number) => {
			if (idx + 1 < arrAnchorDot.length) {
				const nextItem = arrAnchorDot[idx + 1];
				// tslint:disable-next-line:max-line-length
				htmlDot += `<svg><line x1="${item.x + (12 / 2)}" y1="${item.y + (12 / 2)}" x2="${nextItem.x + (12 / 2)}" y2="${nextItem.y + (12 / 2)}" style="stroke:${colorLine};stroke-width:1" /></svg>`;
			}
		});
		return htmlDot;
	}

	const toggleDiceChart = (numDice: number) => {
		if (numDice === 1) {
			isHideDice1.current = !isHideDice1.current;
			btnxnDisa1.current = isHideDice1.current ? '_kochon' : '';
		} else if (numDice === 2) {
			isHideDice2.current = !isHideDice2.current;
			btnxnDisa2.current = isHideDice2.current ? '_kochon' : '';
		} else if (numDice === 3) {
			isHideDice3.current = !isHideDice3.current;
			btnxnDisa3.current = isHideDice3.current ? '_kochon' : '';
		}
	}

	useEffect(() => {
		const getResultLatest = wsData.slice(0, 16);
		const listHisPhien = getResultLatest.reverse();
		if( wsData && listHisPhien.length <= 0 ) {
			return;
		}
		// START render title chart
		const getLatestItem = listHisPhien[listHisPhien.length - 1];
		// tslint:disable-next-line:max-line-length
		getLatestItem.txtResult = (getLatestItem?.result[0] + getLatestItem?.result[1] + getLatestItem?.result[2]) > 10 ? 'Tài' : 'Xỉu';
		getLatest.current = getLatestItem;
		// END render title chart

		// START render chart dot number
		let htmlDotChart = '';
		const arrAnchorDot: any = [];
		const arrDot1: any = [];
		const arrDot2: any = [];
		const arrDot3: any = [];
		listHisPhien.forEach((item: any, idx: number) => {
			arrDot1.push(item.result[0]);
			arrDot2.push(item.result[1]);
			arrDot3.push(item.result[2]);
			const totalDot = item.result[0] + item.result[1] + item.result[2];
			const whDot = 15;
			const wColItem: number = Number(wChart.current) / 15;
			const hColItem: number = Number(hChart.current) / 5;
			const topDot = ((18 - totalDot) / 3) * hColItem - whDot / 2;
			const leftDot = (idx * wColItem) - whDot / 2;
			arrAnchorDot.push({ x: leftDot, y: topDot });
			// tslint:disable-next-line:max-line-length
			htmlDotChart += `<span class="dotP ${totalDot > 10 ? 'dotTai' : 'dotXiu'}" style="top: ${topDot}px; left: ${leftDot}px">${totalDot}</span>`;
		});
		arrAnchorDot.forEach((item: any, idx: number) => {
			if (idx + 1 < arrAnchorDot.length) {
				const nextItem = arrAnchorDot[idx + 1];
				// tslint:disable-next-line:max-line-length
				htmlDotChart += `<svg><line x1="${item.x + (15 / 2)}" y1="${item.y + (15 / 2)}" x2="${nextItem.x + (15 / 2)}" y2="${nextItem.y + (15 / 2)}" style="stroke:rgb(255 255 255);stroke-width:1" /></svg>`;
			}
		});
		if (elWrapChar.current)
			elWrapChar.current.innerHTML = htmlDotChart;
		// END render chart dot number

		// START render chart dot
		if (elWrapDiceChar1.current)
			elWrapDiceChar1.current.innerHTML = renderChartDot123(arrDot1, 'rgb(255 82 0)', 'dot1');
		if (elWrapDiceChar2.current)
			elWrapDiceChar2.current.innerHTML = renderChartDot123(arrDot2, '#fcef54', 'dot2');
		if (elWrapDiceChar3.current)
			elWrapDiceChar3.current.innerHTML = renderChartDot123(arrDot3, '#3ceefe', 'dot3');
		// END render chart dot

		// START render total num dot
		const getResultLatest75 = wsData.slice(0, 75);
		const listTotalPhien = getResultLatest75.map((item: any) => {
			// eslint-disable-next-line no-eval
			item.result = eval(item.result);
			return item;
		}).reverse();
		const arrTempTotalPhienWrap: any = [];
		let j = 0;
		let i = 0;
		const arrTotalDot: any = [];
		listTotalPhien.forEach((item: any) => {
			const totalDot = item.result[0] + item.result[1] + item.result[2];
			arrTotalDot.push(totalDot);
		});
		arrTotalDot.forEach((totalDot: any) => {
			if (totalDot > 10) {
				if (arrTempTotalPhienWrap[j] && arrTempTotalPhienWrap[j].length === 5) {
					j += 1;
				}
				if (!arrTempTotalPhienWrap[j]) {
					arrTempTotalPhienWrap[j] = [];
					i = j + 1;
				}
				arrTempTotalPhienWrap[j].push(totalDot);
			} else {
				if (arrTempTotalPhienWrap[i] && arrTempTotalPhienWrap[i].length === 5) {
					i += 1;
				}
				if (!arrTempTotalPhienWrap[i]) {
					arrTempTotalPhienWrap[i] = [];
					j = i + 1;
				}
				arrTempTotalPhienWrap[i].push(totalDot);
			}
		});
		const arrTopTotal = arrTempTotalPhienWrap.slice(arrTempTotalPhienWrap.length - 15, arrTempTotalPhienWrap.length);
		let htmlTotalNumDot = '';
		totalNumTai.current = 0;
		totalNumXiu.current = 0;
		arrTopTotal.forEach((item: Array<any>, idx: number) => {
			item.forEach((subItem, idxSub) => {
				subItem > 10 ? totalNumTai.current += 1 : totalNumXiu.current += 1;
				const wColItem: number = Number(wChart.current) / 15;
				const hColItem: number = Number(hChart.current) / 5;
				const topDot = idxSub * hColItem + 1;
				const leftDot = (idx * wColItem) + 10;
				// tslint:disable-next-line:max-line-length
				htmlTotalNumDot += `<span class="dotP ${subItem > 10 ? 'dotTai' : 'dotXiu'}" style="top: ${topDot}px; left: ${leftDot}px">${subItem}</span>`;
			});
		});
		if (elWrapTotal.current)
			elWrapTotal.current.innerHTML = htmlTotalNumDot;
		// END render total num dot

		// START render dot
		let htmlDotNums = '';
		let nextCol = 0;
		totalDotTai.current = 0;
		totalDotXiu.current = 0;
		arrTotalDot.forEach((item: any, idx: number) => {
			item > 10 ? totalDotTai.current += 1 : totalDotXiu.current += 1;
			const colVal = idx % 5;
			if (colVal === 0 && idx > 0) {
				nextCol += 1;
			}
			const wColItem: number = Number(wChart.current) / 15;
			const hColItem: number = Number(hChart.current) / 5;
			const topDot = colVal * hColItem + 1;
			const leftDot = (nextCol * wColItem) + 10;
			// tslint:disable-next-line:max-line-length
			htmlDotNums += `<span class="dotP ${item > 10 ? 'dotTai' : 'dotXiu'}" style="top: ${topDot}px; left: ${leftDot}px"></span>`;
		});
		if (elWrapTotalDice.current)
			elWrapTotalDice.current.innerHTML = htmlDotNums;
		// END render dot
	}, [wsData]);

	return (
		<>
			<div id="lsp">
				<section className="lsp-txcb">
					<div className="wrapper">
						<div className="title">LỊCH SỬ PHIÊN</div>
						<div className="close" onClick={onClose}> {/* Replace with actual close function */}
							<img src={require(`assets/images/txcanban/statis/close.png`)} alt="Close" />
						</div>
						<div className="inner">
							<div id="chartPhien" className={classNames({ hiddenBlock: isHideChartPhien.current })}>
								
								<div className="titleLSP">
									<p>Phiên gần nhất: <span>#{getLatest.current.id}</span></p>
									<p className="laterResult">{getLatest.current.txtResult} ({getLatest.current.result.join("-")})</p>
								</div>
								<div className="tblLSP tblTopTotalChart">
									<div className="totalDice">
										{[18, 15, 12, 9, 6, 3].map(num => <span key={num}>{num}</span>)}
									</div>
									<div className="wrapDotTotalChart">
										<div className="chartItems" ref={elWrapChar}></div>
										<table>
											<tbody>
												{[...Array(5)].map((_, rowIndex) => (
												<tr key={rowIndex}>
													{[...Array(15)].map((_, colIndex) => <td key={colIndex}></td>)}
												</tr>
												))}
											</tbody>
										</table>
									</div>
								</div>
								<div className="tblLSP tblBottomDiceChart">
									<div className="totalDice">
										{[6, 5, 4, 3, 2, 1].map(num => <span key={num}>{num}</span>)}
									</div>
									<div className="wrapDotDiceItems">
										<div key={1} ref={elWrapDiceChar1} className={`chartDice ${isHideDice1.current ? "hiddenDice" : ""}`}></div>
										<div key={2} ref={elWrapDiceChar2} className={`chartDice ${isHideDice2.current ? "hiddenDice" : ""}`}></div>
										<div key={3} ref={elWrapDiceChar3} className={`chartDice ${isHideDice3.current ? "hiddenDice" : ""}`}></div>
										<table>
											<tbody>
												{[...Array(5)].map((_, rowIndex) => (
												<tr key={rowIndex}>
													{[...Array(15)].map((_, colIndex) => <td key={colIndex}></td>)}
												</tr>
												))}
											</tbody>
										</table>
									</div>
								</div>
								<div className="btnToggleDice">
									{[1, 2, 3].map(dice => (
										<button key={dice} className="btnGame" onClick={() => toggleDiceChart(dice)}>
											<img src={require(`assets/images/txcb/button_xingau_${dice}${dice === 1 ? btnxnDisa1.current : dice === 2 ? btnxnDisa2.current : btnxnDisa3.current}.png`)} alt="Toggle Dice" />
										</button>
									))}
								</div>
							</div>

							<div id="totalPhien" className={classNames({ hiddenBlock: isHideTotalPhien.current })}>
								
								<div className="titleLSP">
									<div className="txtTotal txtTotalTai">Tài: {totalNumTai.current}</div>
									<div className="txtTotal txtTotalXiu">Xỉu: {totalNumXiu.current}</div>
								</div>
								<div className="tblLSP tblTopTotalChart">
									<div className="wrapDotTotalChart">
										<div className="chartItems" ref={elWrapTotal}></div>
										<table>
											<tbody>
												{[...Array(5)].map((_, rowIndex) => (
												<tr key={rowIndex}>
													{[...Array(15)].map((_, colIndex) => <td key={colIndex}></td>)}
												</tr>
												))}
											</tbody>
										</table>
									</div>
								</div>
								<div className="titleLSP">
									<div className="txtTotal txtTotalTai">Tài: {totalDotTai.current}</div>
									<div className="txtTotal txtTotalXiu">Xỉu: {totalDotXiu.current}</div>
								</div>
								<div className="tblLSP tblTopTotalChart">
									<div className="wrapDotTotalChart">
										<div className="chartItems" ref={elWrapTotalDice}></div>
										<table>
											<tbody>
												{[...Array(5)].map((_, rowIndex) => (
												<tr key={rowIndex}>
													{[...Array(15)].map((_, colIndex) => <td key={colIndex}></td>)}
												</tr>
												))}
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</>
	);
}
